import React from "react";
import NiceModal, {useModal} from "@ebay/nice-modal-react";
import {toast} from "sonner";
import {Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import {Colors, Text} from "@bounce/shared/ui";
import {useDeletePaymentFlow} from "../../apis/requests/payment-flows/deletePaymentFlow";
import {Button} from "../../ui/components";

export type DeletePaymentFlowCopy = {
  title: string;
  warning: string;
};

type Props = DeletePaymentFlowCopy & {
  flowId: number;
  flowName: string;
};

const DeletePaymentFlowDialog = NiceModal.create(({flowId, flowName, title, warning}: Props) => {
  const modal = useModal();
  const {mutateAsync: deleteAsync, isPending: isDeleting} = useDeletePaymentFlow();

  const handleConfirm = async () => {
    try {
      await deleteAsync({id: flowId});
      toast.success(`"${flowName}" deleted`);
      modal.hide();
    } catch {}
  };

  return (
    <Dialog
      open={modal.visible}
      onClose={() => modal.hide()}
      slotProps={{
        transition: {onExited: () => modal.remove()},
        paper: {sx: {borderRadius: "16px"}},
      }}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{p: 3, pb: 0}}>
        <Text size={24} variant="interDisplay600">
          {title}
        </Text>
      </DialogTitle>
      <DialogContent sx={{p: 3, display: "flex", flexDirection: "column", gap: 1, mt: 1}}>
        <Text size={14} sx={{color: Colors.grey._900}}>
          Are you sure you want to delete &quot;{flowName}&quot;?
        </Text>
        <Text size={13} sx={{color: Colors.grey._700}}>
          {warning}
        </Text>
      </DialogContent>
      <DialogActions sx={{p: 3, pt: 0, justifyContent: "flex-end", gap: 1}}>
        <Button buttonType="outlined-secondary" size="small" onClick={() => modal.hide()} disabled={isDeleting}>
          Cancel
        </Button>
        <Button buttonType="contained-error" size="small" onClick={handleConfirm} disabled={isDeleting}>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
});

export default DeletePaymentFlowDialog;
